/** @jsxImportSource @emotion/react */

import moment from "moment";
import { BettingRecordType } from "types/bettingrecord";

import { TableBettingRecordStyle } from "./style.index";

interface Props {
  content?: string;
  item?: BettingRecordType;
  index?: number;
}

const TableBettingRecord = ({ content, index, item }: Props) => {
  if (!!content)
    return (
      <span
        css={[
          TableBettingRecordStyle.item,
          (index === 3 || index === 4) && TableBettingRecordStyle.flex,
        ]}
      >
        {content}
      </span>
    );

  return (
    <table css={TableBettingRecordStyle.wrapper}>
      <tr css={TableBettingRecordStyle.item}>
        <th>Loại game</th>
        <td>{item?.Provider}</td>
      </tr>
      <tr css={TableBettingRecordStyle.item}>
        <th>Tên trò chơi</th>
        <td>{item?.Game}</td>
      </tr>
      <tr css={TableBettingRecordStyle.item}>
        <th>Thời gian thanh toán</th>
        <td>{moment(item?.Date).format("DD/MM/YYYY")}</td>
      </tr>

      <tr css={TableBettingRecordStyle.item}>
        <th>Cược</th>
        <td>+ {item?.Stake} VND</td>
      </tr>

      <tr
        css={[
          TableBettingRecordStyle.item,
          TableBettingRecordStyle.colorText(Number(item?.Winlose)),
        ]}
      >
        <th>Thanh toán</th>
        <td>{`${item?.Winlose}VND`}</td>
      </tr>
    </table>
  );
};

export default TableBettingRecord;
